(ns app.domain.public-notice.template-config
  (:require [app.domain.party.model :as party-model]
            [app.domain.template.model :as template-model]))


(def public-notice-template-variables
  (-> [{:variable-name "header"}
       {:variable-name "application-number"}
       {:variable-name "workspace-id"}
       {:variable-name "project-name"}
       {:variable-name "applicant" :snippet? true}
       {:variable-name "applicant-name"}
       {:variable-name "property-owner" :snippet? true}
       {:variable-name "property-owner-name"}
       {:variable-name "agent" :snippet? true}
       {:variable-name "parties" :snippet? true}
       {:variable-name "municipality-name"}
       {:variable-name "municipal-address"}]
      (into (template-model/as-variable-name-maps template-model/address-placeholders))
      (into [{:variable-name "roll-number"}
             {:variable-name "legal-description"}
             {:variable-name "zoning"}
             {:variable-name "category"}
             {:variable-name "scope"}
             {:variable-name "proposed-use"}
             {:variable-name "description"}
             {:variable-name "meeting-notes"}
             {:variable-name "meeting-name"}
             {:variable-name "meeting-description"}
             {:variable-name "meeting-date"}
             {:variable-name "meeting-time"}
             {:variable-name "current-date"}
             {:variable-name "current-user"}
             {:variable-name "permit-type"}
             {:variable-name "form-data"}
             {:variable-name "review-comments"}
             {:variable-name "latest-review-comments"}
             {:variable-name "qr-code"}])))


(def deprecated-variables #{"workspace-id" "description"})


(def public-notice-template-ui-variables
  (->> public-notice-template-variables
       (map :variable-name)
       (remove deprecated-variables)))


(defn public-notice-picker-variables
  "Hide unit-related placeholders when `:feature-flag.id/property-db-units` is off."
  [feature-flags]
  (template-model/filter-unit-placeholders public-notice-template-ui-variables feature-flags))

(def party-snippet-configs
  [{:template-reference "applicant"
    :pdf-title          :letter/applicant-snippet
    :db-reference       :public-notice-document.template/applicant-snippet
    :template-variables party-model/snippet-variables}
   {:template-reference "property-owner"
    :pdf-title          :letter/property-owner-snippet
    :db-reference       :public-notice-document.template/property-owner-snippet
    :template-variables party-model/snippet-variables}
   {:template-reference "agent"
    :pdf-title          :public-notice/agent-snippet
    :db-reference       :public-notice-document.template/agent-snippet
    :template-variables party-model/snippet-variables}
   {:template-reference "parties"
    :pdf-title          :public-notice/parties-snippet
    :db-reference       :public-notice-document.template/party-snippet
    :template-variables party-model/snippet-variables}])
